
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'FavortiesFormDialog',

  emits: ['save-favorite'],

  setup() {
    const name = ref<string>('');

    const isDialogOpen = ref<boolean>(false);

    const open = ():void => {
      isDialogOpen.value = true;
    };

    const close = ():void => {
      isDialogOpen.value = false;
    };

    return {
      name,
      isDialogOpen,
      open,
      close,
    };
  },
});
